import { useRouter } from '../../components/contexts/RouterContextManager';

const useBasicLayout = () => {
    const { layout } = useRouter();

    if (layout?.__typename !== 'BasicLayout') {
        throw new Error('Unexpected Layout type');
    }

    return layout;
};

export default useBasicLayout;
